import React, { useState } from 'react'
import AdminHeader from '../../components/admin/AdminHeader'
import MarginWrapper from '../../components/util/MarginWrapper'
import StandardInput from '../../components/input/StandardInput'
import { StandardInputModeValues } from '../../components/modes/StandardInputMode'
import StandardButton from '../../components/buttons/StandardButton'
import ApiManager from '../../manager/ApiManager'
import { type GetInterviewAnalyzingResultDto, IntelligentSearchControllerApi } from '../../api/ic'
import { InputModeValues } from '../../components/modes/InputModes'
import { ButtonModeValues } from '../../components/modes/ButtonMode'
import RecordingCard from '../../components/cards/RecordingCard'
import { NavigationRoute } from '../../enumeration/NavigationRoute'

function CorporateAdminCreateTaker () {
  const intelligentSearchController = ApiManager.getInstance(IntelligentSearchControllerApi)
  const [interviews, setInterviews] = useState<GetInterviewAnalyzingResultDto[]>([])
  const [queryLoading, setQueryLoading] = useState(false)
  const aiSearchGivers = () => {
    setQueryLoading(true)
    void intelligentSearchController.intelligentInterviewSearch({
      giverIntelligentSearchRequestDto: { prompt }
    }).then((res: GetInterviewAnalyzingResultDto[]) => {
      setInterviews(res)
      setQueryLoading(false)
    }).catch(() => { setQueryLoading(false) })
  }
  const [prompt, setPrompt] = useState('')
  return (
    <div className={'d-flex flex-column align-items-center justify-content-center'} style={{ width: '100vw' }}>
      <AdminHeader title={'Search Job Seekers'}/>
      <div className={'d-flex flex-column justify-content-center w-75 px-2'}>
        <StandardInput
          label={'Prompt'}
          inputValue={prompt}
          dontAlignStart
          sizeMode={InputModeValues.TEXT_AREA_MAX}
          labelFontSize={30}
          setInputValue={setPrompt}
          type={StandardInputModeValues.TEXT_AREA}
          placeHolder={'Show me users that have excellent knowledge in Java Spring and Python Generators'}/>
      </div>
      <div className={'d-flex flex-row justify-content-end w-75 px-2'}>
        <MarginWrapper top={'20px'}>
          <StandardButton
            isLoading={queryLoading}
            onClick={aiSearchGivers}
            sizeMode={ButtonModeValues.SMALL}
          />
        </MarginWrapper>
      </div>
      {interviews.length > 0 && (
        <div className="row mt-5" style={{ maxWidth: '75vw' }}>
          {interviews.map((interview, index) => (
            <div
              onClick={() => { window.open(NavigationRoute.INTERVIEW_RECORDING.replace(':interviewID', interview.interview.id), '_blank') }}
              className={'col-lg-3 col-md-6 col-sm-12 mt-2 mb-2 p-2'}
              key={index}>
              <RecordingCard
                obj={interview.interview}
                averagePoints={interview.averagePoints}
              />
            </div>
          ))}
        </div>
      )}

    </div>
  )
}

export default CorporateAdminCreateTaker
